import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class GlobalLoaderService {
  private activeRequests = 0;
  private routeLoading = false;
  private waitForCounterCompletion = false;
  private readonly loaderSubject = new BehaviorSubject<boolean>(false);
  readonly loader$ = this.loaderSubject.asObservable();
  private loaderHideTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private routeLoadingTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private readonly ROUTE_LOADING_FALLBACK_MS = 3000;

  show() {
    if (this.loaderHideTimeoutId) {
      clearTimeout(this.loaderHideTimeoutId);
      this.loaderHideTimeoutId = null;
    }
    this.activeRequests++;
    this.updateLoaderState();
  }

  hide() {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }

    if (this.activeRequests === 0) {
      this.loaderHideTimeoutId = setTimeout(() => {
        if (this.waitForCounterCompletion) {
          this.routeLoading = false;
          this.waitForCounterCompletion = false;
        }
        this.updateLoaderState();
        this.loaderHideTimeoutId = null;
      }, 100);
    }
  }

  startRouteLoading() {
    if (this.loaderHideTimeoutId) {
      clearTimeout(this.loaderHideTimeoutId);
      this.loaderHideTimeoutId = null;
    }
    if (this.routeLoadingTimeoutId) {
      clearTimeout(this.routeLoadingTimeoutId);
      this.routeLoadingTimeoutId = null;
    }
    this.routeLoading = true;
    this.waitForCounterCompletion = true;
    this.updateLoaderState();
    this.routeLoadingTimeoutId = setTimeout(() => {
      this.routeLoading = false;
      this.waitForCounterCompletion = false;
      this.updateLoaderState();
      this.routeLoadingTimeoutId = null;
    }, this.ROUTE_LOADING_FALLBACK_MS);
  }

  completeRouteLoading() {
    if (this.routeLoadingTimeoutId) {
      clearTimeout(this.routeLoadingTimeoutId);
      this.routeLoadingTimeoutId = null;
    }
    if (this.activeRequests === 0) {
      this.routeLoading = false;
      this.waitForCounterCompletion = false;
    }
    this.updateLoaderState();
  }

  hideLoading() {
    if (this.activeRequests === 0) {
      this.routeLoading = false;
      this.waitForCounterCompletion = false;
    }
    if (this.routeLoadingTimeoutId) {
      clearTimeout(this.routeLoadingTimeoutId);
      this.routeLoadingTimeoutId = null;
    }
    setTimeout(() => {
      this.updateLoaderState();
    }, 500);
  }

  reset() {
    if (this.loaderHideTimeoutId) {
      clearTimeout(this.loaderHideTimeoutId);
      this.loaderHideTimeoutId = null;
    }
    if (this.routeLoadingTimeoutId) {
      clearTimeout(this.routeLoadingTimeoutId);
      this.routeLoadingTimeoutId = null;
    }
    this.activeRequests = 0;
    this.routeLoading = false;
    this.waitForCounterCompletion = false;
    this.updateLoaderState();
  }

  private updateLoaderState() {
    this.loaderSubject.next(this.routeLoading || this.activeRequests > 0);
  }
}